import { skipToken, useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { EnvelopeAuditListDto, EnvelopeDto } from '@lib/dto/envelope.dto'
import { useEnvelopeAccess } from '@/envelopes/EnvelopeAccess'
import { envelopeKeys } from '@/hooks/queryKeys'

export function useEnvelope(id: string | undefined): UseQueryResult<EnvelopeDto> {
  const { service, cacheKey } = useEnvelopeAccess()
  return useQuery({
    queryKey: envelopeKeys.detail(cacheKey, id),
    queryFn: id ? () => service.get(id) : skipToken,
  })
}

export function useEnvelopeAudit(id: string | undefined): UseQueryResult<EnvelopeAuditListDto> {
  const { service, cacheKey } = useEnvelopeAccess()
  return useQuery({
    queryKey: envelopeKeys.audit(cacheKey, id),
    queryFn: id ? () => service.audit(id) : skipToken,
  })
}
